import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { TechnicalConceptAPI } from "../../modules/TechnicalConcept/api/technicalConceptAPI";
import { useCustomToast } from "../../components";

const keyQuery = ["TechnicalConcept"];
const keyMutation = ["createOnlineInventory"];
const { showToast } = useCustomToast();

export const useFetchTechnicalConcept = (filters?: any) => {
  return useQuery({
    queryKey: [...keyQuery, filters || {}],
    queryFn: ({ queryKey }) => TechnicalConceptAPI.fetchMovements({ queryKey }),
    enabled: true,
  });
};
export const useFetchTechnicalConceptById = (id?: string, fromApprvals?: boolean) => {
  return useQuery({
    queryKey: fromApprvals ? ['ApprovalsTechnicalConcept', id] : [...keyQuery, id],
    queryFn: () => (id ? TechnicalConceptAPI.fetchConceptPetition(id) : Promise.resolve(undefined)),
    enabled: !!id,
    staleTime: 0,
  });
};

export const useCreateTechnicalConcept = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: keyMutation,
    mutationFn: (formData: FormData) =>
      TechnicalConceptAPI.createConceptPetition(formData),
    onSuccess: (rawResponse: any) => {
      const body = rawResponse.data ?? rawResponse;

      if (!body.success) {
        showToast('error', body.message);
      }

      queryClient.invalidateQueries({ queryKey: keyQuery });
    },
    onError: (error: any) => {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Error al guardar la solicitud';
      showToast('error', msg);
      throw error;
    },
  });
};

export const useFetchTechnicalConceptDetail = (ticketId: string) => {
  const queryKey = ["TechnicalConceptDetail", ticketId];

  return useQuery({
    queryKey,
    queryFn: () => TechnicalConceptAPI.fetchConceptPetition(ticketId),
    enabled: !!ticketId,
  });
};

export const useDownloadFilesTechnicalConcept = () => {
  const { showToast } = useCustomToast();

  return useMutation({
    mutationFn: ({ conceptId, ticket }: { conceptId: string; ticket: string }) =>
      TechnicalConceptAPI.downloadFiles(conceptId, ticket),

    onSuccess: () => {
      showToast('success', 'Exportación exitosa');
    },
    onError: () => {
      showToast('error', 'Error al exportar');
    },
  });
};

export const useDownloadPdfTecnhicalConcept = () =>{
  const { showToast } = useCustomToast();
  return useMutation({
    mutationFn: (conceptId: string) => TechnicalConceptAPI.downloadFileConceptZip(conceptId),
    onSuccess: () => {
      showToast('success', 'Exportación exitosa');
    },
    onError: () => {
      showToast('error', 'Error al exportar');
    },
  })
}

